// extracted by mini-css-extract-plugin
export default {"download-template":"UsersTab_download-template__wLPSO","icon":"UsersTab_icon__I6vRs"};